import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, FileTextIcon, ImageIcon, UsersIcon, SettingsIcon, LogOutIcon, PartyPopperIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { useAdmin } from '../../contexts/AdminContext';
interface AdminSidebarProps {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}
const AdminSidebar: React.FC<AdminSidebarProps> = ({
  collapsed,
  setCollapsed
}) => {
  const {
    logout,
    user
  } = useAdmin();
  const location = useLocation();
  const navItems = [{
    path: '/admin',
    label: 'Dashboard',
    icon: <LayoutDashboardIcon size={20} data-id="element-138" />,
    exact: true
  }, {
    path: '/admin/content',
    label: 'Content',
    icon: <FileTextIcon size={20} data-id="element-139" />
  }, {
    path: '/admin/media',
    label: 'Media',
    icon: <ImageIcon size={20} data-id="element-140" />
  }, {
    path: '/admin/people',
    label: 'People',
    icon: <UsersIcon size={20} data-id="element-141" />
  }, {
    path: '/admin/anniversary',
    label: 'Anniversary',
    icon: <PartyPopperIcon size={20} data-id="element-142" />
  }, {
    path: '/admin/settings',
    label: 'Settings',
    icon: <SettingsIcon size={20} data-id="element-143" />
  }];
  return <div className={`bg-blue-950 text-white transition-all duration-300 flex flex-col h-screen sticky top-0 ${collapsed ? 'w-20' : 'w-64'}`} data-id="element-144">
      {/* Logo Area */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-blue-900/50" data-id="element-145">
        {!collapsed && <div className="flex items-center gap-2 overflow-hidden whitespace-nowrap" data-id="element-146">
            <div className="w-8 h-8 bg-yellow-500 rounded flex items-center justify-center font-bold text-blue-950 flex-shrink-0" data-id="element-147">
              IGS
            </div>
            <span className="font-bold text-lg tracking-tight" data-id="element-148">
              Admin Portal
            </span>
          </div>}
        {collapsed && <div className="w-8 h-8 bg-yellow-500 rounded flex items-center justify-center font-bold text-blue-950 mx-auto" data-id="element-149">
            IGS
          </div>}
      </div>

      {/* Navigation */}
      <div className="flex-1 overflow-y-auto py-6 px-3 space-y-2" data-id="element-150">
        {navItems.map(item => {
        // Fix active state logic
        const isActive = item.exact ? location.pathname === item.path : location.pathname.startsWith(item.path) && item.path !== '/admin';
        return <NavLink key={item.path} to={item.path} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${isActive ? 'bg-blue-800 text-yellow-400' : 'text-blue-200 hover:bg-blue-900/50 hover:text-white'}`} title={collapsed ? item.label : undefined} data-id="element-151">
              <div className="flex-shrink-0" data-id="element-152">{item.icon}</div>
              {!collapsed && <span className="font-medium whitespace-nowrap" data-id="element-153">
                  {item.label}
                </span>}
            </NavLink>;
      })}
      </div>

      {/* User Area & Collapse Toggle */}
      <div className="border-t border-blue-900/50 p-4" data-id="element-154">
        {!collapsed && <div className="mb-4 flex items-center gap-3 overflow-hidden" data-id="element-155">
            <div className="w-10 h-10 rounded-full bg-blue-800 flex items-center justify-center text-yellow-400 font-bold flex-shrink-0" data-id="element-156">
              {user?.name.charAt(0) || 'A'}
            </div>
            <div className="whitespace-nowrap" data-id="element-157">
              <p className="text-sm font-bold text-white truncate" data-id="element-158">
                {user?.name || 'Admin User'}
              </p>
              <p className="text-xs text-blue-300 truncate" data-id="element-159">
                {user?.role || 'Administrator'}
              </p>
            </div>
          </div>}

        <div className={`flex ${collapsed ? 'flex-col gap-4 items-center' : 'items-center justify-between'}`} data-id="element-160">
          <button onClick={logout} className="flex items-center gap-2 text-blue-300 hover:text-red-400 transition-colors p-2 rounded-lg hover:bg-blue-900/50" title="Logout" data-id="element-161">
            <LogOutIcon size={20} data-id="element-162" />
            {!collapsed && <span className="text-sm font-medium" data-id="element-163">Logout</span>}
          </button>

          <button onClick={() => setCollapsed(!collapsed)} className="p-2 rounded-lg bg-blue-900 text-blue-300 hover:text-white hover:bg-blue-800 transition-colors" data-id="element-164">
            {collapsed ? <ChevronRightIcon size={20} data-id="element-165" /> : <ChevronLeftIcon size={20} data-id="element-166" />}
          </button>
        </div>
      </div>
    </div>;
};
export default AdminSidebar;